import React from 'react';
import InlineTextButton from '@dyl/components/InlineTextButton';
import useDialog from '@dyl/hooks/useDialog';
import { DialogContentText } from '@mui/material';

/**
 * Displays the underlined text 'Read more', and shows a dialog with the given
 *  content when clicked.
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.title
 * @param {React.ReactChild} props.children
 * @param {string} [props.className]
 * @param {{ text: string, onClick: () => void }[]} [props.actions]
 * @param {boolean} [props.disableClose]
 */
export default function ReadMore({
    label = 'Read more',
    title = '',
    children,
    className: propsClass,
    actions = [],
    disableClose = false,
    ...other
}) {
    const [ImperativeDialog, openDialog] = useDialog();

    const onClick = () => openDialog(
        title,
        (
            <DialogContentText component='div'>
                {children}
            </DialogContentText>
        ),
        [
            ...(actions ?? []),
            ...(!disableClose ? [{ text: 'Close' }] : []),
        ],
        { dismissible: !disableClose }
    );

    return (
        <>
            <InlineTextButton onClick={onClick} {...other}>
                {label}
            </InlineTextButton>

            <ImperativeDialog />
        </>
    );
}